/**
 * object to query string
 * if no object is provided, function will return original data
 * @param  {Object} data
 * @return {string}
 */
__.objectToQueryString = function(data) {
  return __.isObject(data) ? __.getQueryString(data) : data;
};
